/**
 * What a room's non-staging contents LOOK like — identity, model and pose of
 * every object the stager does not own.
 *
 * Shared because it is now RECORDED: whoever places a room's accessories (the
 * browser's Add accessories, or the `style_room_decor` tool) writes the
 * signature of the room it planned against as `room.stagingFixtureSignature`.
 * A room whose current signature no longer matches that record had a fixture
 * change since its accessories were placed, and they are re-planned — however
 * and whenever the change happened. Staging objects are excluded so a
 * re-stage cannot look like a change and trigger another one.
 *
 * Moved here from `web-app/src/utils/objectVisibility.js` (which re-exports
 * it) so the server writes exactly the string the browser compares.
 *
 * @param {Object} room
 * @returns {string}
 */

const { isStagingDecor } = require('./ownership');

function roomFixtureSignature(room) {
  return (room?.objects || [])
    .filter((o) => !isStagingDecor(o))
    .map((o) =>
      [
        o?.id,
        o?.modelId || o?.modelUrl || '',
        o?.dimensions?.x,
        o?.dimensions?.y,
        o?.dimensions?.z,
        o?.center?.x,
        o?.center?.y,
        o?.center?.z,
        o?.rotation?.y,
      ].join(':')
    )
    .sort()
    .join('|');
}

module.exports = { roomFixtureSignature };
